<template>
  <div>
    <section
      v-show="sidebarCurrentPanel === 'modifiers'"
      class="kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open">
      <div class="kp-modular-tab pt-page no-fade pt-page-current">
        <header class="kp-modular-title">
          Configurações
        </header>
        <div class="submenu-content sub-color">
          <header-config></header-config>
          <div v-for="subItem in subItems" class="kp-list-group-item clearfix">
            <label
              class="kp-row box-title box-title__button"
              style="cursor: pointer"
              @click="sidebarSetElement(subItem)">
              {{ subItem.getAttribute('klickbox-edit-label') }}
              <div class="pull-right">
                <span class="btn is-circular has-icon"><i class="fa fa-cog"></i></span>
              </div>
            </label>
            <span></span>
          </div>
          <div class="submenu-padding">
            <div v-for="modifier in modifiers">
              <editor :modifier="modifier" :general="stepPreview.isGeneral" :item="item"></editor>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import HeaderConfig from './Header';
import Editor from './editors/Main';

export default {
  data() {
    return {
      subItems: [],
    };
  },
  components: {
    HeaderConfig,
    Editor,
  },
  updated() {
    setTimeout(() => {
      this.subItems = document.querySelectorAll(`[klickbox-edit-item-dad="${this.item}"]`);
    }, 0);
  },
  computed: mapGetters({
    sidebarCurrentPanel: 'sidebarCurrentPanel',
    modifiers: 'sidebarElementModifiers',
    item: 'sidebarElementItem',
    stepPreview: 'stepPreview',
  }),
  methods: mapActions([
    'sidebarSetElement',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?3897c595
 **/